/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeTotalFollowedGroupResponse } from "./MeTotalFollowedGroupResponse";

export type MeTotalFollowedGroupResponseApiRespoonse = {
  data?: MeTotalFollowedGroupResponse;
  status?: MeTotalFollowedGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeTotalFollowedGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
